// src/components/stats/SearchResults.jsx -- presentational list of player-search
// candidates. No business logic: renders what StatsPage passes and reports picks
// through onPick. Spec v1b-amendment §C4.

import { leagueLabel, positionLabel, rosterStatusBadge } from '../../lib/player-stats-display';

// IL/Optioned pill (Issue 2). IL = red-ish, Optioned = amber. Renders nothing for an
// Active/null/unknown-to-badge status (rosterStatusBadge returns null).
function StatusBadge({ status }) {
  const badge = rosterStatusBadge(status);
  if (!badge) return null;
  const isIL = badge.label === 'IL';
  return (
    <span
      title={badge.title}
      style={{
        fontSize: 10, fontWeight: 800, letterSpacing: 0.3, textTransform: 'uppercase',
        padding: '2px 6px', borderRadius: 6, whiteSpace: 'nowrap',
        color: isIL ? '#fca5a5' : '#fcd34d',
        background: isIL ? 'rgba(248,113,113,0.12)' : 'rgba(251,191,36,0.12)',
        border: `1px solid ${isIL ? 'rgba(248,113,113,0.35)' : 'rgba(251,191,36,0.35)'}`,
      }}
    >
      {badge.label}
    </span>
  );
}

export default function SearchResults({ players, onPick }) {
  return (
    <ul style={{ listStyle: 'none', margin: '8px 0 0', padding: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
      {players.map((p) => (
        <li key={`${p.league}:${p.player_id}`}>
          <button
            type="button"
            onClick={() => onPick(p)}
            style={{
              width: '100%', textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit',
              background: '#0b1626', border: '1px solid #1e293b', borderRadius: 12,
              padding: '12px 14px', color: '#e2e8f0', display: 'flex', alignItems: 'center',
              justifyContent: 'space-between', gap: 10,
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
              <span style={{ fontWeight: 700, fontSize: 14 }}>{p.name}</span>
              <StatusBadge status={p.roster_status} />
            </span>
            <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 700 }}>
              {[p.team, positionLabel(p.position, p.league), p.league ? leagueLabel(p.league) : '']
                .filter(Boolean).join(' · ')}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
